import { render, staticRenderFns } from "./cardFeaturedSponsors.vue?vue&type=template&id=14da7ac9&scoped=true"
import script from "./cardFeaturedSponsors.vue?vue&type=script&lang=js"
export * from "./cardFeaturedSponsors.vue?vue&type=script&lang=js"
import style0 from "./cardFeaturedSponsors.vue?vue&type=style&index=0&id=14da7ac9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14da7ac9",
  null
  
)

export default component.exports